<div  *ngIf="(branchDaySupplyOverview)">
  <div class="wrapper">
     Tank level
      <kendo-arcgauge style="display:block;height:125px;width:125px;"   [value]="silolevel.val" [scale]="{ min:0, max: 100  }">
        <ng-template   kendoArcGaugeCenterTemplate   let-value="value" >
          <span >{{ GetValue(silolevel) }} <app-unit *ngIf="branchDaySupplyOverview" [unit]="branchDaySupplyOverview.silolevel.variable.unit"></app-unit> </span>
        </ng-template>
      </kendo-arcgauge>
  </div>

  Start Program &nbsp; {{ startprogram.val }}   <br/>
  Runs  {{ nrruntoday.val  }}  <br/>

</div>

